export const translateJobType = (type, language = "pt") => {
  const translations = {
    FULL_TIME: {
      pt: "Tempo Integral",
      en: "Full Time",
    },
    PART_TIME: {
      pt: "Meio Período",
      en: "Part Time",
    },
    FIXED_TERM: {
      pt: "Determinado",
      en: "Fixed Term",
    },
    INTERNSHIP: {
      pt: "Estágio",
      en: "Internship",
    },
    FREELANCE: {
      pt: "Freelance",
      en: "Freelance",
    },
  };

  return translations[type]?.[language] || "N/A";
};

export const translateCareerLevel = (level, language = "pt") => {
  const translations = {
    TRAINEE: {
      pt: "Estagiário",
      en: "Trainee",
    },
    JUNIOR: {
      pt: "Júnior",
      en: "Junior",
    },
    MID: {
      pt: "Pleno",
      en: "Mid Level",
    },
    SENIOR: {
      pt: "Sênior",
      en: "Senior",
    },
    HEAD: {
      pt: "Líder/Chefe",
      en: "Head/Lead",
    },
  };

  return translations[level]?.[language] || "N/A";
};

export const translateSector = (sector, language = "pt") => {
  const translations = {
    PRIVATE: {
      pt: "Privado",
      en: "Private",
    },
    PUBLIC: {
      pt: "Público",
      en: "Public",
    },
    ONG: {
      pt: "ONG",
      en: "NGO",
    },
  };

  return translations[sector]?.[language] || "N/A";
};
